import { App } from 'antd'
import { useEffect } from 'react'

type FeedbackApi = Pick<ReturnType<typeof App.useApp>, 'message' | 'modal' | 'notification'>

let feedbackApi: FeedbackApi | null = null

export function useFeedback() {
    const { message, modal, notification } = App.useApp()
    return { message, modal, notification }
}

export function AntdAppRegistrar() {
    const { message, modal, notification } = useFeedback()

    useEffect(() => {
        feedbackApi = { message, modal, notification }

        return () => {
            if (feedbackApi?.message === message) {
                feedbackApi = null
            }
        }
    }, [message, modal, notification])

    return null
}

function getFeedback() {
    if (!feedbackApi) {
        throw new Error('Antd feedback API is not ready yet.')
    }

    return feedbackApi
}

export const feedback = {
    get message() {
        return getFeedback().message
    },
    get modal() {
        return getFeedback().modal
    },
    get notification() {
        return getFeedback().notification
    },
}
